var chunkToChildrenMap = {
	"1877": [
		8714
	],
	"2791": [
		3658
	],
	"3178": [
		1169
	],
	"4071": [
		8315
	],
	"4595": [
		8714,
		1498
	],
	"6591": [
		2412
	],
	"8944": [
		3286
	],
	"9824": [
		1169,
		2898
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));